import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.upsells != this.props.upsells) {
            return true;
        }

        return false;
    }

    render({ upc, url, upsells, report }) {
        if (
            report
            && report.product_code
            && report.product_code.includes('sample')
            && report.constants
            && report.constants.product_slug
        ) {
            const url = new URL(report.upsell_url);

            return (
                <tarot-report-button upc={upc} url={url}>
                    <a
                        className={`button ${upsells ? 'is-block-mobile' : '' }`}
                        href={`${url.pathname}${url.search}`}
                        onClick={(e) => this.handleClick(e, `${url.pathname}${url.search}`)}
                    >
                        REVEAL MORE <br className='is-visible-mobile' />
                        CARDS
                    </a>
                </tarot-report-button>
            );
        }

        return (
            <tarot-report-button upc={upc} url={url}>
                <a
                    className={`button-warning ${upsells ? 'is-block-mobile' : '' }`}
                    href={url}
                    onClick={this.handleClick}
                >
                    REPEAT <span className='is-hidden-mobile'>THIS </span>
                    <br className='is-visible-mobile' />
                    READING
                </a>
            </tarot-report-button>
        );
    }

    handleClick = (e, upsell_url) => {
        e.preventDefault();

        const promo = ['Tarot Reading Upsell'];

        if (upsell_url) {
            promo.push(this.props.upc);

            this.props.trackEvent([
                'Free 3-Card Upsell',
                'Click',
                this.props.report.upsell_upc == 'celtic-cross-10-card-love-redux' ? 'Love' : 'General',
                `Readings_${this.props.report.upsell_upc}:Upsell`,
            ]);
        } else {
            promo.push(`Repeat: ${this.props.upc}`);

            this.props.trackEvent([
                'Tarot Reading Upsell',
                'Click',
                `Repeat: ${this.props.upc}`,
                `Readings_${this.props.upc}:Repeat`,
            ]);
        }

        this.props.trackPromo(promo);

        document.location = upsell_url ? upsell_url : this.props.url;
    }
}

const mapStateToProps = (state) => ({
    upsells: state.product && state.product.upsells,
    report: state.report,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (action) => dispatch({ type: 'ga:event', payload: action }),
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
